import React from 'react'
import PropTypes from 'prop-types'

const CopyHtmlButton = ({ onClick, disabled, isCopied }) => {
 return (
    <button
      onClick={onClick}
      type="button"
      className="me-2 btn btn-sm btn-primary"
      disabled={disabled}
    >
      { isCopied
        ? <i className="fas fa-check-circle fs-4 me-2"/>
        : <i className="fas fa-file-code fs-4 me-2"/>
      }
      Copy Html
    </button>
  )
}

CopyHtmlButton.propTypes  = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  isCopied: PropTypes.bool.isRequired,
}

export default CopyHtmlButton